export default __webpack_public_path__ + "static/media/logo.730ccbf2.png";